import { connect } from 'react-redux';
import View from './AssetClassesView';
import { fetchAssetClasses, saveAssetClasses, resetState } from './AssetClassesActions';
import {
  hasLoadedSelector,
  assetClassesOptionsSelector,
  assetClassesMappingSelector,
} from './AssetClassesSelector';

const mapStateToProps = state => ({
  hasLoaded: hasLoadedSelector(state),
  assetClassesOptions: assetClassesOptionsSelector(state),
  assetClassMappings: assetClassesMappingSelector(state),
});

const mapDispatchToProps = {
  fetchAssetClasses,
  saveAssetClasses,
  resetState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
